export default __webpack_public_path__ + "static/media/healthwise_keys.e3be2fb7.csv";